import React from 'react';
import type { StringMap } from 'corgi-types';

import Alert from 'common/components/Alert';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { HeaderOptions } from '../components/constants';

interface AlertProps {
  headerOptions: HeaderOptions;
  alertTranslationProps: StringMap<string | number>;
}

export const useAlert = ({ headerOptions, alertTranslationProps }: AlertProps) => {
  const { r } = useLocalization();
  const { alertType, alertMessage, AlertComponent } = headerOptions || {};

  return AlertComponent ? (
    <AlertComponent
      alertType={alertType}
      alertMessage={alertMessage}
      alertTranslationProps={alertTranslationProps}
    />
  ) : (
    alertType && alertMessage && (
      <Alert type={alertType} mt="sp_16" aria-live="polite" aria-atomic="true">
        {r.t(alertMessage, alertTranslationProps)}
      </Alert>
    )
  );
};
